// components/templates/sections/Newsletter.tsx (fixed)
'use client';
import { useState } from 'react';
import { useDesign } from '@/context/DesignContext';

interface NewsletterProps {
  title?: string;
  buttonText?: string;
  placeholder?: string;
  design?: any;
}

export default function Newsletter({ title, buttonText, placeholder, design: propDesign }: NewsletterProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;
  const [isMagnified, setIsMagnified] = useState(false);

  if (!title && !buttonText) return null;

  const primaryColor = design?.colors?.primary || '#C8A96E';
  const textColor = design?.colors?.text || '#F5F5F5';
  const textLightColor = design?.colors?.textLight || '#A3A3A3';
  const borderColor = design?.colors?.border || '#262626';
  const headingFont = design?.typography?.headingFont || "'Cormorant Garamond', serif";
  const bodyFont = design?.typography?.bodyFont || "'Inter', sans-serif";
  const btnPrimary = design?.buttons?.primary || { backgroundColor: 'transparent', borderColor: primaryColor, textColor: primaryColor, padding: '12px 28px' };

  return (
    <section className="px-8 md:px-16 py-24 flex flex-col md:flex-row items-center justify-between gap-12 border-t" style={{ borderColor: `${primaryColor}1F` }}>
      <div className="max-w-md">
        <div className="text-xs uppercase tracking-widest mb-3" style={{ fontFamily: bodyFont, color: primaryColor }}>— Inner Circle</div>
        {title && <h3 className="font-serif text-4xl md:text-5xl font-light leading-tight" style={{ fontFamily: headingFont, color: textColor }}>{title}</h3>}
      </div>
      <div className="flex flex-col sm:flex-row gap-0 w-full max-w-md border" style={{ borderColor: `${primaryColor}4D` }}>
        <input
          type="email"
          placeholder={placeholder || "your@email.com"}
          className="flex-1 bg-transparent px-6 py-4 text-sm tracking-widest font-light outline-none placeholder-stone-600"
          style={{ color: textLightColor, fontFamily: bodyFont }}
        />
        {buttonText && (
          <button
            className="text-xs uppercase tracking-widest whitespace-nowrap transition-all"
            style={{
              background: btnPrimary.backgroundColor,
              border: btnPrimary.borderColor ? `1px solid ${btnPrimary.borderColor}` : 'none',
              color: btnPrimary.textColor,
              padding: btnPrimary.padding,
            }}
            onMouseEnter={(e) => {
              setIsMagnified(true);
              e.currentTarget.style.background = btnPrimary.backgroundColor === 'transparent' ? primaryColor : btnPrimary.backgroundColor;
              e.currentTarget.style.color = btnPrimary.backgroundColor === 'transparent' ? design?.colors?.secondary || '#0F0F0F' : btnPrimary.textColor;
            }}
            onMouseLeave={(e) => {
              setIsMagnified(false);
              e.currentTarget.style.background = btnPrimary.backgroundColor;
              e.currentTarget.style.color = btnPrimary.textColor;
            }}
          >
            {buttonText}
          </button>
        )}
      </div>
    </section>
  );
}